@if (data.title) {
  <h2 class="text-heading-2" mat-dialog-title>
    {{ useTranslation ? (data.title | transloco) : data.title }}
  </h2>
}
<div mat-dialog-content>
  <div
    [innerHtml]="
      useTranslation
        ? (data.message | isTranslationObject)
          ? (data.message.key | transloco: data.message.params | stripNewLine)
          : (data.message | transloco | stripNewLine)
        : data.message
    "
  ></div>
  @if (error(); as err) {
    <rma-callout class="mt-3" calloutType="error" [message]="err" />
  }
</div>
<div mat-dialog-actions align="end">
  <button type="button" (click)="close(false)" mat-button color="primary" mat-dialog-close>
    {{ data.cancelButtonText ? (useTranslation ? (data.cancelButtonText | transloco) : data.cancelButtonText) : 'Cancel' }}
  </button>
  <button
    type="button"
    [color]="data.severity === 'error' ? 'warn' : 'primary'"
    [rmaLoadingIndicator]="showLoading()"
    (click)="close(true)"
    mat-flat-button
  >
    {{ useTranslation ? (data.buttonText | transloco) : data.buttonText }}
  </button>
</div>
